import * as React from "react";
import { Button, Input, Label, ImagePicker } from 'uxp/components';
import { IUIPropertyDefinition } from '../common';
import { Property, RemoveButton } from "./common";
import { $L } from '../../../localize';

export function MultipleImagesProperty(title: string, props: string[], showCategoryTitle = false): IUIPropertyDefinition<string[]> {
    return {
        defaults: props,
        render: (props) => {

            const imageUrls: string[] = props.uiProps || [];

            return <div className='wd-prop-item'>
                {!!showCategoryTitle && <div className='wd-prop-item-title'>{title}</div>}

                <div className='wd-prop-item-editor'>
                    <Label>{title}</Label>
                    {!imageUrls.length && <Label>No Images were added</Label>}
                    <div>

                        {imageUrls.map((imageUrl, i) => {

                            return <div className="ui-field-config-item-row">
                                <div className="column" style={{ flexGrow: 1 }}>
                                    <ImagePicker
                                        value={imageUrl || ''}
                                        onChange={s => {
                                            const newImageUrls = [...imageUrls]
                                            newImageUrls[i] = s
                                            props.onChange(newImageUrls)
                                        }}
                                    />
                                </div>

                                <div className="column action-column" style={{ marginLeft: '20px' }}>
                                    <RemoveButton onClick={() => {
                                        const newImageUrls = [...imageUrls]
                                        newImageUrls.splice(i, 1)
                                        props.onChange(newImageUrls)
                                    }} />
                                </div>
                            </div>
                        })}
                        <Button
                            className="new-option"
                            title={$L('widgetdesigner.props.add-new-image', 'Add New Image')}
                            icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                            iconPosition="right"
                            onClick={() => {
                                const newImageUrls = [...imageUrls, '']
                                props.onChange(newImageUrls)
                            }}
                        />
                    </div>
                </div>
            </div>;
        }
    };
}